PJQ.views.submittals.EditSubmittalModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Modal-Edit-Submittal'),
        subTemplates: {
            contactBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input-Contacts'),
            comments: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Comments'),
        },
        width: '90%',
        maxWidth: 1500,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close',
        'click .submittal-delete': 'delete',
        'click .btn-add-comment': 'addCommentClicked',
        'click .btn-mark-submitted': 'submit',
        'click .btn-submit': 'submit',
        'click .btn-approve': 'approve',
        'click .btn-reject': 'reject',
        'click .btn-notification-history': 'viewNotificationHistory',
        'click .btn-edit-history': 'viewEditHistory',
        'click .btn-upload-files': 'uploadFile',
        'click .edit-file': 'editFileClicked',
        'click .edit-note': 'editNoteClicked',
        'click .btn-dl-approver-attachment': 'downloadAttachment',
        'click .btn-download-all-attachments': 'downloadAllAttachments',
        'click .expand-history': 'renderHistory',
        'click .download-history-file': 'downloadHistoryClicked',
        'click .btn-export': 'exportSubmittal',
        'click .btn-delete-comment': 'deleteComment',
        'click .btn-void': 'voidSubmittal',
        'click .btn-edit-workflow': 'editWorkflow',
        'click .btn-save-workflow': 'saveWorkflow',
        'click .btn-view-revision': 'viewRevision',
        'click .btn-create-revision': 'createRevision',
        'click .btn-submittal-respond': 'respondToSubmittal',
        'click .btn-close-submittal': 'closeSubmittal',
        'click .btn-email-submittal': 'emailSubmittal',
        'click .btn-distribute-submittal': 'distributeSubmittal',
        'click .btn-reopen-submittal': 'reopenSubmittal'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.options.project != null) {
            this.options.isAdmin = this.options.project.hasPermission('submittals.isAdmin');
        } else {
            this.options.isAdmin = true;
        }
        this.options.canEditPeople = this.options.isAdmin;
        this.options.canEdit = true;
        this.options.canUpload = true;
        this.options.canSubmit = this.options.project != null;

        if (this.model == null) {
            let submitter;
            if (!this.options.isAdmin) {
                submitter = PJQ.app.session.contact != null ? PJQ.app.session.contact : PJQ.app.session.user;
            }

            this.model = new PJQ.models.submittals.Submittals({
                projectId: this.options.project ? this.options.project.id : null,
                templateId: this.options.templateId,
                submitter: submitter ? submitter.toJSON() : null
            });
        }

        if (this.options.project != null) {
            this.options.settings = await this.options.project.fetchSubmittalSettings();
            this.options.itemTypes = await this.options.project.fetchSubmittalItemTypes();
            this.options.customFields = await this.options.project.fetchSubmittalCustomFields();
            this.options.statuses = await this.options.project.fetchSubmittalStatuses();
        } else {
            this.options.settings = await PJQ.app.session.fetchSubmittalSettings();
            this.options.itemTypes = await PJQ.app.session.fetchSubmittalItemTypes();
            this.options.customFields = await PJQ.app.session.fetchSubmittalCustomFields();
            this.options.statuses = await PJQ.app.session.fetchSubmittalStatuses();
        }
        this.changedAnnotations = new PJQ.collections.drawings.Annotations();

        if (this.model.isNew()) {
            let defaultNewStatus = this.options.statuses.findWhere({
                    isDefault: true,
                    type: PJQ.constants.submittals.statusTypes.NEW
                }),
                defaultManager = this.options.settings?.get('defaultManager'),
                defaultDistributionList = this.options.settings?.get('defaultDistributionList');

            this.model.set('statusId', defaultNewStatus.id);

            if (defaultManager && this.options.settings?.get('enableWorkflow')) {
                this.model.manager = new PJQ.models.projectContacts.ProjectContact(defaultManager);
                this.model.set('managerId', defaultManager);
            }

            if (defaultDistributionList) {
                this.model.distributionList = new PJQ.collections.projectContacts.ProjectContacts(defaultDistributionList);
                this.model.set('distributionList', defaultDistributionList);
            }

            if(this.options.settings?.get('extendedSettings').defaultIsPublic){
                this.model.set('isPublic', true);
            }
        } else {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        let searchId = PJQ.app.session.contact ? PJQ.app.session.contact.get('id') : PJQ.app.session.user.get('id'),
            isSubmitter = this.model.get('isSubmitter') || (this.model.submitter && this.model.submitter.id === searchId),
            isCreator = this.model.get('isCreator') || (this.model.createdBy && this.model.createdBy.id === searchId);

        this.options.canEditPeople = this.options.isAdmin;
        this.options.isApprover = this.model.get('isApprover') || null != _.findWhere(this.model.get('approvers'), {id: searchId});
        if (this.model.isNew()) {
            this.options.canEdit = true;
            this.options.canUpload = true;
            this.options.canSubmit = this.options.project != null;
        } else if (this.model.get('hasRevision') || this.model.get('isClosed') || this.model.isVoidStatus(this.options.statuses)) {
            this.options.canEditPeople = false;
            this.options.canEdit = false;
            this.options.canUpload = false;
            this.options.canSubmit = false;
        } else if (this.model.get('isClosed') || this.model.isApprovedStatus(this.options.statuses) || this.model.isVoidStatus(this.options.statuses)) {
            this.options.canEdit = false;
            this.options.canUpload = false;
            this.options.canSubmit = false;
        } else if (this.model.isPartiallyApproved()) {
            this.options.canEdit = this.options.isAdmin;
            this.options.canUpload = this.options.isAdmin || this.options.isApprover;
            this.options.canSubmit = false;
        } else if (this.model.isSubmittedStatus(this.options.statuses)) {
            this.options.canEdit = this.options.isAdmin;
            this.options.canUpload = this.options.isAdmin || (!this.options.settings.get('enableWorkflow') && this.options.isApprover);
            this.options.canSubmit = false;
        } else {
            this.options.canEditPeople = this.options.isAdmin;
            this.options.canEdit = this.options.isAdmin;
            this.options.canSubmit = this.options.project != null && (this.options.isAdmin || this.options.isApprover || isSubmitter || isCreator);
            this.options.canUpload = this.options.canSubmit || isCreator
        }

        if (this.model.statusShouldLock(this.options.statuses)) {
            this.options.canEdit = false;
            this.options.canEditPeople = false;
            this.options.canSubmit = false;
            this.options.canUpload = false;
            this.options.isApprover = false;
        }

        this.options.hideItemTypes = PJQ.app.session.project ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.HIDE_SUBMITTAL_ITEM_TYPE) : PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.HIDE_SUBMITTAL_ITEM_TYPE);
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project,
            customFields: this.options.customFields,
            settings: this.options.settings,
            statuses: this.options.statuses,
            itemTypes: this.options.itemTypes ? this.options.itemTypes : null,
            canEdit: this.options.canEdit,
            canEditPeople: this.options.canEditPeople,
            canSubmit: this.options.canSubmit,
            isAdmin: this.options.isAdmin,
            isApprover: this.options.isApprover,
            canUpload: this.options.canUpload,
            hideItemTypes: this.options.hideItemTypes,
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.options.itemTypes == null || !this.options.itemTypes.isFetched
            || this.options.customFields == null || !this.options.customFields.isFetched) {
            return;
        }
        if (this.options.project) {
            PJQ.app.session.project.fetchSubmittalCustomFields(_.bind(function (customFields) {
                this.customFields = customFields;
                this.renderCustomFields();
            }, this));
        }

        if (this.options.canEdit) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input',
                    'textarea'
                ]
            });
        }

        this.dueDatePicker = new PJQ.inputs.Datepicker({
            el: this.$('.input-due-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('dueDate') ? new Date(this.model.get('dueDate')) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dueDate', newDate);
            }, this)
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.input-received-date'),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('receivedDate') ? new Date(this.model.get('receivedDate')) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('receivedDate', newDate);
            }, this)
        });

        new PJQ.views.groups.GroupsSelectInput({
            el: this.$('.submittal-groups'),
            isShowAddButton: false,
            addButton: this.$('.btn-edit-groups'),
            groupLevels: PJQ.app.session.project ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS) : PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LEVELS),
            groupUserId: PJQ.app.session.project ? PJQ.app.session.project.get('masterUserId') : PJQ.app.session.get('masterUserId'),
            selectedGroups: this.model.groups.models,
            isReadOnly: !this.options.canEdit,
            onAfterSave: _.bind(function (selectedGroups) {
                this.model.groups.reset(selectedGroups);
                this.model.isDirty = true;
            }, this)
        });

        if (this.model.ballInCourt || (this.options.settings.get('enableWorkflow') && this.model.isSubmittedStatus(this.options.statuses) && this.model.workflow.getCurrentStep() != null && _.size(this.model.workflow.getCurrentStep()?.get('approvers')) > 0)) {
            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.submittal-ball-in-court'),
                selectedContact: this.model.ballInCourt ?? _.map(this.model.workflow.getCurrentStep().approvers.models, (approver) => {
                    return new PJQ.models.projectContacts.ProjectContact(approver.get('person'))
                }),
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                isSingleChoice: this.model.ballInCourt != null,
                isReadOnly: true,
                displayContactsBlock: true
            });
        }

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.submittal-submitter'),
            selectedContact: this.model.submitter,
            canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEditPeople,
            displayContactsBlock: true,
            canSwitchContext: this.options.project == null,
            context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
            isSingleChoice: true,
            onChange: (selectedContact) => {
                this.model.submitter = selectedContact;
                this.model.isDirty = true;
            }
        });
        let approvers = [];
        _.each(this.model.get('approvers'), function (approver) {
            approvers.push(new PJQ.models.projectContacts.ProjectContact(approver));
        })

        if (this.options.settings.get('enableWorkflow') && (!this.model.isNew() || this.options.isAdmin)) {
            if (this.options.project != null) {
                this.workflowView = new PJQ.views.submittals.WorkflowView({
                    el: this.$('.workflow-outer'),
                    model: this.model.workflow,
                    submittal: this.model,
                    project: this.options.project,
                    isEdit: this.model.isNew() && this.options.isAdmin,
                    canChangeBallInCourt: this.options.canEdit && this.options.isAdmin && !this.model.get('isClosed') && this.model.isSubmittedStatus(this.options.statuses),
                    canEdit: this.options.canEdit && this.options.isAdmin && !this.model.get('isClosed') && !this.model.isApprovedStatus(this.options.statuses) && !this.model.isVoidStatus(this.options.statuses),
                    canRespond: !this.model.get('isClosed'),
                    onChange: () => {
                        this.model.isDirty = true;
                    },
                    onRespond: () => {
                        this.render();
                    },
                    onSetBallInCourt: () => {
                        this.render();
                    }
                });
            }

            this.managerPicker = new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.submittal-manager'),
                selectedContact: this.model.manager,
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                canEdit: this.options.canEditPeople,
                displayContactsBlock: true,
                canSwitchContext: this.options.project == null,
                context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: true,
                onChange: _.bind(function (selectedContact) {
                    this.model.manager = selectedContact;
                    this.model.isDirty = true;
                }, this)
            });
        } else {
            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.submittal-approval-list'),
                subTemplates: {
                    contactBadge: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Approver-Input-Contacts')
                },
                isSortable: true,
                allowDuplicate: this.options.settings.get('approvalMode') === PJQ.constants.submittals.approvalModes.SEQUENTIAL,
                onStop: (array) => {
                    let approvers = this.model.get('approvers'),
                        newApprovers = [],
                        usedIdx = [];
                    _.each(array, function (id) {
                        let approverIdx = _.findIndex(approvers, function (approver, idx) {
                            return approver.id === id && usedIdx.indexOf(idx) === -1;
                        });
                        if (approverIdx === -1) {
                            return;
                        }
                        usedIdx.push(approverIdx);

                        newApprovers.push(approvers[approverIdx]);
                    });
                    this.model.set('approvers', newApprovers);
                    this.model.isDirty = true;
                },
                contactsRenderData: {
                    isAdmin: this.options.isAdmin,
                    showApproval: (contact, index) => {
                        return this.model.isSubmittedStatus(this.options.statuses);
                    },
                    canApprove: (contact, index) => {
                        return !contact.get('hasApproved') && this.model.isSubmittedStatus(this.options.statuses)
                            && this.model.isUserCurrentApprover(this.options.settings.get('approvalMode'), contact);
                    }
                },
                onApproveBehalf: (contact) => {
                    this.model.set('asNotedCommentId', null);

                    let isNew = this.model.isNew(),
                        fnApprove = (comment) => {
                            // todo: save comment
                            this.model.approve(null, contact.id, (success, err) => {
                                if (!success) {
                                    if (!this.handleStatusError(err)) {
                                        let errTxt = 'Encountered an error while approving the submittal';
                                        PJQ.notifications.notify.errorNotify({
                                            message: errTxt
                                        });
                                    }
                                    return;
                                }

                                if (this.options.onSave) {
                                    this.options.onSave(this.model, isNew);
                                }
                                this.render();
                            });
                        };

                    new PJQ.views.modals.YesNo({
                        header: "Add comment?",
                        body: 'Would you like to include a comment on behalf of this approver?',
                        onYes: () => {
                            this.checkActiveResponse(false, (hadComment) => {
                                if (!hadComment) {
                                    new PJQ.views.submittals.StatusChangeCommentModal({
                                        model: this.model,
                                        title: 'Submission Note',
                                        onSave: _.bind(function (model, comment) {
                                            fnApprove(comment);
                                        }, this)
                                    })
                                } else {
                                    fnApprove();
                                }
                            });
                        },
                        onNo: () => {
                            fnApprove();
                        }
                    });
                },
                selectedContact: approvers,
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                canEdit: this.options.canEditPeople,
                displayContactsBlock: true,
                context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: false,
                canSwitchContext: this.options.project == null,
                onChange: (selectedContacts) => {
                    let newApprovers = [],
                        approvedByIds = _.map(_.filter(this.model.get('approvers'), (approver) => {
                            return approver.hasApproved;
                        }), (approver) => {
                            return approver.id;
                        });
                    _.each(selectedContacts, function (contact) {
                        let existApproverIdx = approvedByIds.indexOf(contact.id)
                        contact.set({
                            isApprover: true,
                            hasApproved: existApproverIdx !== -1
                        });
                        newApprovers.push(contact);

                        if (existApproverIdx !== -1) {
                            delete approvedByIds[existApproverIdx];
                        }
                    }, this)
                    this.model.set('approvers', newApprovers);
                    this.model.isDirty = true;
                }
            });
        }

        if (this.options.isAdmin) {
            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.submittal-distribution-list'),
                selectedContact: this.model.distributionList.models,
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                canEdit: this.options.canEditPeople,
                displayContactsBlock: true,
                canSwitchContext: this.options.project == null,
                context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: false,
                onChange: _.bind(function (selectedContacts) {
                    this.model.distributionList.reset(selectedContacts);
                    this.model.isDirty = true;
                }, this)
            });
        }

        if (!this.options.hideItemTypes) {
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-item-type'),
                noneSelectedText: 'Select Value',
                isMultiple: true,
                isIntChoices: true,
                defaultValue: _.map(this.model.itemTypes.models, function (model) {
                    return model.id;
                }),
                onChange: _.bind(function (value) {
                    this.model.itemTypes.reset(this.options.itemTypes.get(value));
                    this.model.isDirty = true;
                }, this)
            });
        }

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.submittal-file-uploader'),
            context: 'submittal',
            contextId: this.model.id,
            canAddAnnotations: this.options.canEdit,
            onAnnotationChange: this.model.id > 0 ? null : (annotation) => {
                this.changedAnnotations.merge(annotation);
            },
            mergeAnnotations: this.changedAnnotations,
            collection: this.model.attachments,
            canUpload: this.options.canUpload,
            canDelete: this.options.isAdmin,
            hasNotes: true,
            isVersioned: true,
            versionByName: true,
            previewImageDimension: 150,
            includeProjectAttachments: true,
            onNoteChanged: (attachment) => {
                if (!(attachment.id > 0)) {
                    return;
                }

                new PJQ.ajax.Request({
                    endpoint: this.options.project.endpoint() + '/submittals/attachments/' + attachment.id,
                    isAPIv2: true,
                    data: attachment.toJSON()
                }).patch().done(() => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Attachment note updated'
                    });
                }).fail((xhr, err, result) => {
                    PJQ.notifications.notify.errorNotify({
                        message: 'Encountered an error while updating the attachment note'
                    });
                });
            },
            onNewVersion: () => {
                this.model.isDirty = true;
                this.fileUploader.render();
            },
            onSuccess: () => {
                this.model.isDirty = true;
            },
            onDelete: (attachment, callback) => {
                if (attachment.id > 0) {
                    attachment.set('isDeleted', true);
                } else {
                    this.model.attachments.remove(attachment);
                }
                this.model.isDirty = true;
                callback();
            }
        });

        this.renderCustomFields();
        this.renderComments();
    },
    renderComments: function () {
        this.renderSubTemplate(false, this.options.subTemplates.comments, this.$('.comments-outer'), {
            comments: this.model.comments.models,
            model: this.model,
            settings: this.options.settings,
            statuses: this.options.statuses,
            canDelete: this.options.canEdit && (this.options.project ? this.options.project.hasPermission('submittals.canDeleteComments') : true)
        });
    },
    respondToSubmittal: function (e) {
        let currentStep = this.model.workflow.getCurrentStep();
        if (currentStep == null) {
            return;
        }

        let approver = currentStep.approvers.findWhere({isMe: true});
        new PJQ.views.submittals.WorkflowResponseModal({
            project: this.options.project,
            submittal: this.model,
            approver: approver,
            onSave: () => {
                this.render();
            }
        });
    },
    editWorkflow: function () {
        this.$('.btn-edit-workflow').addClass('hidden');
        this.$('.btn-save-workflow').removeClass('hidden');

        this.workflowView.setEdit(true);
    },
    saveWorkflow: function () {
        this.$('.btn-save-workflow').addClass('hidden');
        this.$('.btn-edit-workflow').removeClass('hidden');

        this.workflowView.setEdit(false);
    },
    viewRevision: function () {
        let lastRevisionId = this.model.get('lastRevisionId');
        if (lastRevisionId == null) {
            return;
        }

        this.removeModal();

        let revision = new PJQ.models.submittals.Submittals({
            submittalId: lastRevisionId
        });
        new PJQ.views.submittals.EditSubmittalModal({
            model: revision,
            project: this.options.project,
            onSave: this.options.onSave,
            onClose: this.options.onClose,
            onDelete: this.options.onDelete
        });
    },
    createRevision: function () {
        this.removeModal();

        let newSubmittal = this.model.clone();
        newSubmittal.set({
            submittalId: null,
            attachments: [],
            comments: [],
            workflow: null,
            submittalNumber: null,
            statusId: null,
            dueDate: null,
            revisionFor: this.model.id,
            isClosed: false
        });
        newSubmittal.attachments = new PJQ.collections.submittals.Attachments();
        newSubmittal.comments = new PJQ.collections.submittals.Comments();

        newSubmittal.workflow = this.model.workflow.clone();

        new PJQ.views.submittals.EditSubmittalModal({
            model: newSubmittal,
            project: this.options.project,
            onSave: this.options.onSave,
            onClose: this.options.onClose,
            onDelete: this.options.onDelete
        });
    },
    closeSubmittal: function () {
        new PJQ.views.submittals.ConfirmSubmittalCloseModal({
            header: "Close Submittal?",
            body: 'Are you sure you want to close this submittal? This will lock the submittal and distribute it to all submittal participants (when selected).',
            statuses: this.options.statuses,
            onConfirm: (opts) => {
                this.model.close(opts, () => {
                    PJQ.notifications.notify.successNotify({
                        message: "Submittal successfully closed" + (opts.distribute ? ' and distributed' : '')
                    });
                    this.render();
                });
            }
        });
    },
    emailSubmittal: function () {
        let projectName = this.options.project?.get('projectName')?.trim(),
            subject = `A Submittal has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            project: PJQ.app.session.project,
            header: "Email Submittal",
            enableCC: false,
            subject: subject,
            onSaveWait: (data, cb) => {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Submittal email sent'
                    });

                    cb();
                }, this));
            }
        });
    },
    reopenSubmittal: function () {
        new PJQ.views.modals.YesNo({
            header: "Reopen Submittal?",
            body: 'Are you sure you want to reopen this submittal?',
            onYes: () => {
                this.model.reopen(() => {
                    PJQ.notifications.notify.successNotify({
                        message: "Submittal successfully reopened"
                    });
                    this.render();
                });
            }
        });
    },
    distributeSubmittal: function () {
        new PJQ.views.modals.YesNo({
            header: "Distribute Submittal?",
            body: 'Are you sure you want to distribute this submittal?',
            onYes: () => {
                this.model.distribute(() => {
                    PJQ.notifications.notify.successNotify({
                        message: "Submittal successfully distributed"
                    });
                    this.render();
                });
            }
        });
    },
    voidSubmittal: function (e) {
        if (this.model.get('templateId') != null) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        let status = null;
        if (this.options.isAdmin && e && e.currentTarget != null) {
            statusId = $(e.currentTarget).data('statusId');
            status = this.options.statuses.get(statusId);
        }

        if (status == null) {
            status = this.options.statuses.findWhere({
                type: PJQ.constants.submittals.statusTypes.VOID,
                isDefault: true
            });
        }

        let isNew = this.model.isNew();
        let fnVoid = (comment) => {
            this.model.void(status.id, (success, err) => {
                if (!success) {
                    if (!this.handleStatusError(err)) {
                        let errTxt = 'Encountered an error while voiding the submittal';
                        PJQ.notifications.notify.errorNotify({
                            message: errTxt
                        });
                    }
                    return;
                }

                if (this.options.onSave) {
                    this.options.onSave(this.model, isNew);
                }
                this.render();
            });
        };

        let asNoted = status.get('asNoted');
        this.checkActiveResponse(asNoted, (hadComment) => {
            if (!hadComment && asNoted) {
                new PJQ.views.submittals.StatusChangeCommentModal({
                    model: this.model,
                    title: 'Void Note',
                    onSave: _.bind(function (model, comment) {
                        fnVoid(comment);
                    }, this)
                })
            } else {
                fnVoid();
            }
        });
    },
    addCommentClicked: function () {
        this.addComment();
    },
    addComment: function (asNoted, callback) {
        let val = this.$('.item-new-comment').val().trim();
        if (_.size(val) === 0) {
            callback(false);
            return;
        }

        let comment = new PJQ.models.submittals.Comment({
            submittalId: this.model.id,
            comment: val,
            createdOn: new Date(),
            asNoted: asNoted === true
        });
        if (!this.model.isNew() && !asNoted) {
            comment.save(null, {
                success: _.bind(function () {
                    this.model.comments.add(comment);
                    this.renderComments();
                    if (typeof callback === 'function') {
                        callback(true);
                    }
                }, this)
            });
        } else {
            comment.createdBy = PJQ.app.session.contact ? PJQ.app.session.contact : PJQ.app.session.user;
            this.model.comments.add(comment);
            this.renderComments();
            if (typeof callback === 'function') {
                callback(true);
            }
        }
        this.$('.item-new-comment').val('');
    },
    deleteComment: function (e) {
        let target = $(e.currentTarget),
            $comment = target.closest('.card'),
            cid = $comment.data().cid,
            comment = this.model.comments.get(cid);

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this comment?",
            onDelete: _.bind(function () {
                this.model.comments.remove(comment);
                comment.destroy();
                this.renderComments();
            }, this)
        });
    },
    renderCustomFields: function () {
        if (_.size(this.options.customFields.models) > 0) {
            this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.submittal-custom-fields'),
                collection: this.options.customFields,
                fieldValues: this.model.get('customFieldValues'),
                isEdit: this.options.canEdit,
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }
    },
    save: function () {
        this.checkActiveResponse(false, () => {
            if (this.fileUploader.isUploading()) {
                new PJQ.views.BaseModal({
                    header: "Files Uploading",
                    body: "You can't save while files are uploading"
                });
            } else {
                let fnDisableButtons = _.bind(function (disable) {
                    this.$('.btn-save').attr('disabled', disable);
                    this.$('.btn-submit').attr('disabled', disable);
                }, this)

                fnDisableButtons(true);
                if (!this.validate()) {
                    fnDisableButtons(false);
                    return;
                }

                PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-company-name'), true);

                let fnSaveAnnotations = (callback) => {
                    _.each(this.changedAnnotations.models, (annotation) => {
                        if (annotation.isNew()) {
                            annotation.set('contextId', this.model.id);
                        }
                    });
                    this.changedAnnotations.saveAll(() => {
                        if (this.options.onSave) {
                            this.options.onSave(this.model, isNew);
                        }

                        let message;
                        if (submitting) {
                            message = 'Submittal submitted successfully';
                        } else {
                            message = 'Submittal saved successfully';
                        }
                        PJQ.notifications.notify.successNotify({
                            message: message
                        });

                        this.removeModal();

                        if (typeof callback === 'function') {
                            callback();
                        }
                    });
                };

                let submitting = this.model.isSubmittedStatus(this.options.statuses) && this.model.initAttributes.statusId !== this.model.get('statusId'),
                    isNew = this.model.isNew();
                if (this.model.hasChanged() || this.model.isNew()) {
                    this.model.save({
                        workflow: this.model.workflow && this.model.workflow.hasChanged() ? this.model.workflow.toJSON() : null,
                    }, {
                        notify: true,
                        success: () => {
                            fnSaveAnnotations();
                        },
                        error: () => {
                            fnDisableButtons(false);
                        }
                    });
                } else {
                    fnSaveAnnotations();
                }
            }
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.model.get('templateId') === null) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    this.onClose(this.model);
                    this.removeModal();
                }, this)
            });
        } else {
            this.onClose(this.model);
            this.removeModal();
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Submittal?",
            onDelete: _.bind(function () {
                if (this.options.onDelete) {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    },
    checkActiveResponse: function (asNoted, callback) {
        let aRes = this.$('.item-new-comment').val();
        if (_.size(aRes) > 0) {
            new PJQ.views.modals.YesNo({
                header: "Post Comment?",
                body: 'You typed a comment but did not click <b>Post Comment</b>.  Would you like to post this comment before continuing?',
                onYes: _.bind(function () {
                    this.addComment(asNoted, (hadComment) => {
                        callback(hadComment);
                    });
                }, this),
                onNo: _.bind(function () {
                    if (typeof callback === 'function') {
                        callback(false);
                    }
                }, this)
            });
        } else {
            if (typeof callback === 'function') {
                callback(false);
            }
        }
    },
    submit: function (e) {
        if (this.model.get('templateId') != null) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        let status = null;
        if (e && e.currentTarget != null) {
            statusId = $(e.currentTarget).data('statusId');
            status = this.options.statuses.get(statusId);
        }

        if (status == null) {
            status = this.options.statuses.findWhere({
                type: PJQ.constants.submittals.statusTypes.SUBMITTED,
                isDefault: true
            });
        }

        let isNew = this.model.isNew();
        let fnSubmit = (comment) => {
            this.model.submit(status.id, (success, err) => {
                if (!success) {
                    if (!this.handleStatusError(err)) {
                        let errTxt = 'Encountered an error while submitting the submittal';
                        PJQ.notifications.notify.errorNotify({
                            message: errTxt
                        });
                    }
                    return;
                }

                if (this.options.onSave) {
                    this.options.onSave(this.model, isNew);
                }
                this.render();
            });
        };

        let asNoted = status.get('asNoted');
        this.checkActiveResponse(asNoted, (hadComment) => {
            if (!hadComment && asNoted) {
                new PJQ.views.submittals.StatusChangeCommentModal({
                    model: this.model,
                    title: 'Submission Note',
                    onSave: _.bind(function (model, comment) {
                        fnSubmit(comment);
                    }, this)
                })
            } else {
                fnSubmit();
            }
        });
    },
    reject: function (e) {
        if (this.model.get('templateId') != null) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        let status = null;
        if (this.options.isAdmin && e && e.currentTarget != null) {
            statusId = $(e.currentTarget).data('statusId');
            status = this.options.statuses.get(statusId);
        }

        if (status == null) {
            status = this.options.statuses.findWhere({
                type: PJQ.constants.submittals.statusTypes.REJECTED,
                isDefault: true
            });
        }

        let isNew = this.model.isNew();
        let fnReject = (comment) => {
            this.model.reject(status.id, (success, err) => {
                if (!success) {
                    if (!this.handleStatusError(err)) {
                        let errTxt = 'Encountered an error while rejecting the submittal';
                        PJQ.notifications.notify.errorNotify({
                            message: errTxt
                        });
                    }
                    return;
                }

                if (this.options.onSave) {
                    this.options.onSave(this.model, isNew);
                }
                this.render();
            });
        };

        let asNoted = status.get('asNoted');
        this.checkActiveResponse(asNoted, (hadComment) => {
            if (!hadComment && asNoted) {
                new PJQ.views.submittals.StatusChangeCommentModal({
                    model: this.model,
                    title: 'Rejection Note',
                    onSave: _.bind(function (model, comment) {
                        fnReject(comment);
                    }, this)
                })
            } else {
                fnReject();
            }
        });
    },
    validate: function () {
        PJQ.helpers.inputHelpers.setInputError(this.$('.input-due-date'), true);
        let dueDateVal = this.$('.input-due-date').val().trim();

        if (_.size(dueDateVal) === 0) {
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-due-date'), false);
            return false;
        }

        if (this.managerPicker != null && !this.managerPicker.validate() && this.options.isAdmin) {
            return false;
        }

        if (this.customFieldsForm && !this.customFieldsForm.validate()) {
            return false;
        }

        return true
    },
    approve: function (e) {
        if (this.model.get('templateId') != null) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        let status = null;
        if (e && e.currentTarget != null) {
            statusId = $(e.currentTarget).data('statusId');
            status = this.options.statuses.get(statusId);
        }

        if (status == null) {
            status = this.options.statuses.findWhere({
                type: PJQ.constants.submittals.statusTypes.APPROVED,
                isDefault: true
            });
        }

        let isNew = this.model.isNew();
        let fnApprove = (comment) => {
            // todo: save comment
            this.model.approve(status.id, null, (success, err) => {
                if (!success) {
                    if (!this.handleStatusError(err)) {
                        let errTxt = 'Encountered an error while approving the submittal';
                        PJQ.notifications.notify.errorNotify({
                            message: errTxt
                        });
                    }
                    return;
                }

                if (this.options.onSave) {
                    this.options.onSave(this.model, isNew);
                }
                this.render();
            });
        };

        let asNoted = status.get('asNoted');
        this.checkActiveResponse(asNoted, (hadComment) => {
            if (!hadComment && asNoted) {
                new PJQ.views.submittals.StatusChangeCommentModal({
                    model: this.model,
                    title: 'Approval Note',
                    onSave: _.bind(function (model, comment) {
                        fnApprove(comment);
                    }, this)
                });
            } else {
                fnApprove();
            }

        });
    },
    handleStatusError: function (err) {
        if (err !== PJQ.constants.submittals.errors.STATUS_NOT_EXISTS) {
            return false;
        }

        let fObj = this.options.project != null ? this.options.project : PJQ.app.session;
        fObj.fetchSubmittalStatuses(true).then((st) => {
            this.options.statuses = st;
            this.render();
        });

        PJQ.notifications.notify.errorNotify({
            message: 'The status you selected no longer exists, please select a different status'
        });
        return true;
    },
    editFile: function (file) {
        new PJQ.views.submittals.FileEditorModal({
            model: file,
            collection: new PJQ.collections.submittals.Attachments(),
            isNewVersion: true,
            onSave: _.bind(function (file) {
                let newFile = file.models[0];
                if (file.models[1].get('submittalDocumentId') === file.models[1].get('parentSubmittalDocumentId')) {
                    newFile.attributes.parentSubmittalDocumentId = file.models[1].get('submittalDocumentId');
                } else {
                    newFile.attributes.parentSubmittalDocumentId = file.models[1].get('parentSubmittalDocumentId');
                }
                _.each(this.model.attachments.models, function (model) {
                    if (model.get('submittalDocumentId') === file.models[1].get('submittalDocumentId')) {
                        model.attributes = newFile.attributes;
                    }
                }, this);
                this.model.isDirty = true;
            }, this)
        });
    },
    uploadFile: function () {
        new PJQ.views.submittals.FileEditorModal({
            collection: new PJQ.collections.submittals.Attachments(),
            isNewVersion: false,
            onSave: _.bind(function (files) {
                _.each(files.models, function (model) {
                    model.attributes.createdOn = new Date();
                    model.attributes.createdByDisplay = model.get('createdBy').contactName;
                    model.attributes.notes = "";
                    model.attributes.versionNumber = 1;
                    this.model.attachments.add(model);
                }, this);
                this.model.isDirty = true;
            }, this)
        });
    },
    editNoteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.filesTable.getRow(target.closest('tr'));
        this.editNote(row);
    },
    editNote: function (file) {
        new PJQ.views.submittals.FileEditorModal({
            model: file,
            isNoteEdit: true,
            collection: new PJQ.collections.submittals.Attachments(),
            isNewVersion: true,
            onSave: _.bind(function () {
                this.model.isDirty = true;
                // this.filesTable.render();
            }, this)
        });
    },
    viewNotificationHistory: function () {
        this.model.fetchNotifications(function (notifications) {
            new PJQ.views.notifications.NotificationHistory({
                collection: notifications
            });
        })
    },
    viewEditHistory: function () {
        this.model.fetchEditHistory(function (editHistory) {
            new PJQ.views.submittals.EditHistoryModal({
                history: editHistory
            })
        })
    },
    exportSubmittal: function () {
        new PJQ.ajax.Request({
            endpoint: this.options.project.endpoint() + '/submittals/' + this.model.get('submittalId') + '/export',
            data: {
                isApi2: true
            }
        }).post().done(_.bind(function (response) {
            PJQ.files.downloadFile(response.url, {
                isEndpoint: false
            });
        }, this)).fail(_.bind(function (xhr, err, result) {
        }, this));
    },
    downloadAttachment: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            attachment = null;
        for (let i = 0; i < this.model.attachments.models.length; i++) {
            let sAttachment = this.model.attachments.models[i];
            if (sAttachment.cid === cid) {
                attachment = sAttachment;
            } else if (sAttachment.versions != null) {
                for (let j = 0; j < sAttachment.versions.models.length; j++) {
                    let ver = sAttachment.versions.models[j];
                    if (ver.cid === cid) {
                        attachment = ver;
                    }
                }
            }

            if (attachment != null) {
                break;
            }
        }
        if (attachment != null) {
            attachment.download();
        }
    },
    downloadAllAttachments: function () {
        this.options.project.downloadAttachments(_.map(this.model.attachments.models, function (attachment) {
            return new PJQ.models.files.File({
                entryId: attachment.get('entryId'),
                guid: attachment.get('guid')
            });
        }));
    }
});

PJQ.views.submittals.ConfirmSubmittalCloseModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-close-submittal'),
        statuses: null
    },
    events: {
        'click .btn-confirm': 'onConfirm',
        'change .cb-distribute': 'onDistributeChange'
    },
    beforeModalCreated: function () {
        this.distribute = true;
    },
    renderData: function () {
        return {
            distribute: this.distribute,
            statuses: this.options.statuses
        };
    },
    afterRender: function () {
        this.selectedStatus = -1;
        if (this.options.statuses != null) {
            this.statusPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-status'),
                defaultValue: this.selectedStatus,
                isIntChoices: true,
                choices: _.union([{
                    id: -1,
                    name: 'Closed'
                }], _.map(_.filter(this.options.statuses.models, (st) => {
                    let tp = st.get('type');
                    return tp === PJQ.constants.submittals.statusTypes.APPROVED
                        || tp === PJQ.constants.submittals.statusTypes.REJECTED;
                }), (st) => {
                    return {
                        id: st.id,
                        name: st.get('name')
                    };
                })),
                onChange: (value) => {
                    this.selectedStatus = value;
                }
            });
        }
    },
    onDistributeChange: function () {
        this.distribute = this.$('.cb-distribute').prop('checked');
        this.render();
    },
    onConfirm: function () {
        if (typeof this.options.onConfirm === 'function') {
            this.options.onConfirm({
                distribute: this.distribute,
                status: this.selectedStatus
            });
        }
        this.removeModal();
    }
});